var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14218 5.95216C8.14218 6.96922 7.37661 7.78303 6.14737 7.78303H6.12484C4.94129 7.78303 4.17615 6.96922 4.17615 5.95216C4.17615 4.91359 4.96459 4.12256 6.1706 4.12256C7.37661 4.12256 8.1193 4.91359 8.14218 5.95216ZM7.90995 9.2288V19.8211H4.38458V9.2288H7.90995ZM20.6237 19.8211L20.6239 13.7479C20.6239 10.4944 18.8847 8.98013 16.5648 8.98013C14.6931 8.98013 13.8551 10.0082 13.3872 10.7295V9.22914H9.86138C9.90785 10.2231 9.86138 19.8214 9.86138 19.8214H13.3872V13.9058C13.3872 13.5893 13.4101 13.2735 13.5033 13.0468C13.7581 12.4144 14.3382 11.7596 15.3121 11.7596C16.5883 11.7596 17.0985 12.7309 17.0985 14.1543V19.8211H20.6237Z",
    fill: "#1E1E2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.7a0086b9011501df97b86c2714b5c9c5.svg";
export { ForwardRef as ReactComponent };